<template>
  <div>
    <v-row v-if="loading || notFound || customError" :align="'center'">
      <v-col :align="'center'" class="page-container__wrapper centered">
        <h1 v-if="notFound" class="display-4">404</h1>
        <h3 v-if="customError">{{ customError }}</h3>
        <v-progress-circular indeterminate color="primary" v-else></v-progress-circular>
      </v-col>
    </v-row>
    <slot v-else></slot>
  </div>
</template>

<script>
export default {
  props: ['loading', 'notFound', 'customError'],
};
</script>
<style lang="scss">
.page-container {
  &__wrapper {
    min-height: 100vh;
  }
}
</style>
